import React, { useState, useEffect } from 'react';
import { 
  X, Search, Lock, Users, Eye, Crown, Send, Clock, 
  MessageCircle, Leaf, Star, AlertCircle, CheckCircle , Hash
} from 'lucide-react';
import { useUser } from '../context/UserContext';
import API_URL from '../config/ApiUrl';
import { useTheme } from '../arrangement/ThemeContext';
import InviteCodeModal from '../sesh_room_components/InviteCodeModal';
const PrivateRoomsModal = ({ 
    isOpen, 
    onClose, 
    currentUser,
    fetchRooms,           // Add this
    setSelectedRoom,      // Add this  
    setCurrentRoom,       // Add this
    setUserRole,          // Add this
    joinVideoRoom         // Add this
  }) => {
  const [privateRooms, setPrivateRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [error, setError] = useState(null);
  const [notification, setNotification] = useState(null);
  const [requestingAccess, setRequestingAccess] = useState(null);
  const [accessMessage, setAccessMessage] = useState('');
  const { user, isAuthenticated } = useUser();
  
  const { colors } = useTheme();
  
  const [showInviteCodeModal, setShowInviteCodeModal] = useState(false);
    console.log()

  // Categories for filtering
  const categories = [
    { id: '', name: 'All Categories', icon: '🌍' },
    { id: 'wake-bake', name: 'Wake & Bake', icon: '🌅' },
    { id: 'chill-sesh', name: 'Chill Sesh', icon: '😌' },
    { id: 'strain-review', name: 'Strain Reviews', icon: '🔍' },
    { id: 'dab-station', name: 'Dab Station', icon: '🔥' },
    { id: 'edible-experience', name: 'Edible Journey', icon: '🍪' },
    { id: 'grow-talk', name: 'Grow Talk', icon: '🌱' },
    { id: 'gaming-high', name: 'Gaming High', icon: '🎮' },
    { id: 'music-vibes', name: 'Music & Vibes', icon: '🎵' },
    { id: 'newbie-friendly', name: 'Newbie Corner', icon: '🤝' },
    { id: 'private-crew', name: 'Private Crew', icon: '🔒' }
  ];

  const handleInviteCodeJoin = (response) => {
    if (response.success) {
      showNotification(response.message);
      fetchRooms(); // Refresh rooms list
      
      // If room is live, auto-join
      if (response.room?.is_live) {
        setSelectedRoom(response.room);
        setCurrentRoom(response.room);
        setUserRole(response.role);
        joinVideoRoom();
      }
    }
  };

  // Fetch private rooms
  const fetchPrivateRooms = async () => {
    if (!isOpen) return;
    
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append('visibility', 'private');
      params.append('discoverable', 'true'); // Only show discoverable private rooms
      if (selectedCategory) params.append('category', selectedCategory);
      if (searchQuery) params.append('search', searchQuery);

      const response = await fetch(`${API_URL}/api/rooms/discover?${params.toString()}`, {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        setPrivateRooms(data.rooms || []);
        setError(null);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to fetch private rooms');
      }
    } catch (err) {
      setError('Network error while fetching rooms');
      console.error('Error fetching private rooms:', err);
    } finally {
      setLoading(false);
    }
  };

  // Request access to a private room
  const handleRequestAccess = async (roomId) => {
    if (!accessMessage.trim()) {
      showNotification('Please enter a message explaining why you want to join', 'error');
      return;
    }

    setRequestingAccess(roomId);
    try {
      const response = await fetch(`${API_URL}/api/rooms/${roomId}/request-access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          message: accessMessage.trim()
        })
      });

      if (response.ok) {
        const data = await response.json();
        showNotification(data.message || 'Access request sent successfully!', 'success');
        setAccessMessage('');
        
        // Update the room status locally
        setPrivateRooms(prevRooms => 
          prevRooms.map(room => 
            room.id === roomId 
              ? { ...room, access_status: 'pending' }
              : room
          )
        );
      } else {
        const errorData = await response.json();
        showNotification(errorData.error || 'Failed to send access request', 'error');
      }
    } catch (err) {
      showNotification('Network error while sending request', 'error');
      console.error('Error requesting access:', err);
    } finally {
      setRequestingAccess(null);
    }
  };

  // Show notification
  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 5000);
  };

  // Load rooms when modal opens or filters change
  useEffect(() => {
    fetchPrivateRooms();
  }, [isOpen, selectedCategory, searchQuery]);
    console.log('privateRooms: ', privateRooms)

  // Filter rooms based on search
  const filteredRooms = privateRooms.filter(room => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return (
        room.title.toLowerCase().includes(query) ||
        room.host?.username.toLowerCase().includes(query) ||
        room.strain?.toLowerCase().includes(query) ||
        room.description?.toLowerCase().includes(query) ||
        room.tags.some(tag => tag.toLowerCase().includes(query))
      );
    }
    return true;
  });

  console.log('filteredRooms: ', filteredRooms)
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0, 0, 0, 0.8)',
      backdropFilter: 'blur(8px)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      {/* Notification */}
      {notification && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 1001,
          padding: '16px 20px',
          background: notification.type === 'error' ? '#ef4444' : '#00d4aa',
          color: 'white',
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          {notification.type === 'error' ? (
            <AlertCircle size={20} />
          ) : (
            <CheckCircle size={20} />
          )}
          {notification.message}
        </div>
      )}

      <div style={{
        background: colors.bgTertiary,
        borderRadius: '24px',
        border: '1px solid #333',
        maxWidth: '900px',
        width: '100%',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          padding: '24px 32px',
          borderBottom: `1px solid ${colors.border}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(16, 185, 129, 0.1) 100%)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{
              width: '48px',
              height: '48px',
              background: 'linear-gradient(135deg, #8b5cf6 0%, #10b981 100%)',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Lock size={24} style={{ color: 'white' }} />
            </div>
            <div>
              <h2 style={{ 
                margin: 0, 
                fontSize: '24px', 
                fontWeight: '700', 
                color: 'white',
                marginBottom: '4px'
              }}>
                Discover Private Rooms
              </h2>
              <p style={{ margin: 0, color: '#888', fontSize: '14px' }}>
                Find and request access to exclusive cannabis communities
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              padding: '12px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              color: '#888',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(239, 68, 68, 0.2)';
              e.currentTarget.style.color = '#ef4444';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.color = '#888';
            }}
          >
            <X size={20} />
          </button>
        </div>

        {/* Search and Filters */}
        <div style={{
          padding: '24px 32px',
          borderBottom: `1px solid ${colors.border}`,
          display: 'flex',
          gap: '16px',
          alignItems: 'center'
        }}>
          <div style={{ position: 'relative', flex: '1' }}>
            <Search size={20} style={{
              position: 'absolute',
              left: '16px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#888'
            }} />
            <input
              type="text"
              placeholder="Search private rooms, hosts, strains..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: '100%',
                paddingLeft: '48px',
                paddingRight: '16px',
                paddingTop: '12px',
                paddingBottom: '12px',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>
          
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            style={{
              padding: '12px 16px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '12px',
              color: 'white',
              fontSize: '14px',
              outline: 'none',
              cursor: 'pointer',
              minWidth: '180px'
            }}
          >
            {categories.map(cat => (
              <option key={cat.id} value={cat.id} style={{ background: colors.bgTertiary, }}>
                {cat.icon} {cat.name}
              </option>
            ))}
          </select>
        </div>

        {/* Content */}
        <div style={{
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Error Display */}
          {error && (
            <div style={{
              margin: '20px 32px',
              background: 'rgba(239, 68, 68, 0.1)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
              borderRadius: '12px',
              padding: '16px',
              color: '#fca5a5',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <AlertCircle size={20} />
              {error}
            </div>
          )}

          {/* Loading State */}
          {loading ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '60px',
              color: '#888'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                border: '4px solid #333',
                borderTop: '4px solid #8b5cf6',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginRight: '16px'
              }} />
              Loading private rooms...
            </div>
          ) : (
            <div style={{
              flex: 1,
              overflowY: 'auto',
              padding: '20px 32px'
            }}>
              {/* Rooms Grid */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
                gap: '20px'
              }}>
                {filteredRooms.map((room) => {
                  const hasRequestedAccess = room.access_status === 'pending';
                  const isApproved = room.access_status === 'approved';
                  const isDenied = room.access_status === 'denied';

                  return (
                    <div key={room.id} style={{
                      background: colors.bgCard,
                      border: '1px solid #444',
                      borderRadius: '16px',
                      overflow: 'hidden',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{ padding: '20px' }}>
                        {/* Room Header */}
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          marginBottom: '16px'
                        }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                              <h3 style={{
                                margin: 0,
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#e5e5e5'
                              }}>
                                {room.title}
                              </h3>
                              <Lock size={16} style={{ color: '#8b5cf6' }} />
                            </div>
                            
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              marginBottom: '8px'
                            }}>
                              <img
                                src={room.host?.avatar_url || `https://api.dicebear.com/7.x/initials/svg?seed=${room.host?.username}`}
                                alt={room.user?.username}
                                style={{
                                  width: '24px',
                                  height: '24px',
                                  borderRadius: '50%'
                                }}
                              />
                              <span style={{ fontSize: '14px', color: '#888' }}>
                                Hosted by {room.user?.username}
                              </span>
                              <Crown size={14} style={{ color: '#fbbf24' }} />
                            </div>
                          </div>
                          
                          {/* Status Badge */}
                          <div style={{
                            padding: '6px 12px',
                            background: hasRequestedAccess 
                              ? '#f59e0b' 
                              : isApproved 
                                ? '#00d4aa' 
                                : isDenied 
                                  ? '#ef4444' 
                                  : room.is_live 
                                    ? '#00d4aa' 
                                    : '#666',
                            borderRadius: '8px',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}>
                            {hasRequestedAccess && (
                              <>
                                <Clock size={12} />
                                PENDING
                              </>
                            )}
                            {isApproved && (
                              <>
                                <CheckCircle size={12} />
                                APPROVED
                              </>
                            )}
                            {isDenied && (
                              <>
                                <X size={12} />
                                DENIED
                              </>
                            )}
                            {!hasRequestedAccess && !isApproved && !isDenied && (
                              <>
                                <div style={{
                                  width: '6px',
                                  height: '6px',
                                  borderRadius: '50%',
                                  background: 'white',
                                  animation: room.is_live ? 'pulse 2s infinite' : 'none'
                                }} />
                                {room.is_live ? 'LIVE' : 'PRIVATE'}
                              </>
                            )}
                          </div>
                        </div>

                        {/* Description */}
                        {room.description && (
                          <p style={{
                            margin: '0 0 16px 0',
                            fontSize: '14px',
                            color: '#ccc',
                            lineHeight: '1.5'
                          }}>
                            {room.description}
                          </p>
                        )}

                        {/* Room Info */}
                        <div style={{
                          padding: '12px',
                          background: colors.bgTertiary,
                          borderRadius: '8px',
                          marginBottom: '16px'
                        }}>
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '8px'
                          }}>
                            <span style={{ fontSize: '12px', color: '#888' }}>Category:</span>
                            <span style={{
                              fontSize: '12px',
                              fontWeight: '600',
                              color: '#8b5cf6'
                            }}>
                              { room.description}
                            </span>
                          </div>
                          {room.strain && (
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}>
                              <span style={{ fontSize: '12px', color: '#888' }}>Strain:</span>
                              <span style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#10b981'
                              }}>
                                🌿 {room.strain}
                              </span>
                            </div>
                          )}
                        </div>

                        {/* Stats */}
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: '16px'
                        }}>
                          {/* <div style={{ display: 'flex', gap: '12px' }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                              fontSize: '12px',
                              color: '#888'
                            }}>
                              <Users size={12} style={{ color: '#8b5cf6' }} />
                              {room.participant_count || 0}/{room.max_participants}
                            </div>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                              fontSize: '12px',
                              color: '#888'
                            }}>
                              <Star size={12} style={{ color: '#fbbf24' }} />
                              {room.rating || 'N/A'}
                            </div>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                              fontSize: '12px',
                              color: '#888'
                            }}>
                              <MessageCircle size={12} style={{ color: '#f59e0b' }} />
                              {room.message_count || 0}
                            </div>
                          </div> */}
                        </div>

                        {/* Tags */}
                        {room.tags && room.tags.length > 0 && (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '16px' }}>
                            {room.tags.slice(0, 4).map((tag, i) => (
                              <span key={i} style={{
                                padding: '2px 6px',
                                background: '#333',
                                borderRadius: '4px',
                                fontSize: '10px',
                                color: '#888'
                              }}>
                                #{tag}
                              </span>
                            ))}
                            {room.tags.length > 4 && (
                              <span style={{
                                padding: '2px 6px',
                                background: '#333',
                                borderRadius: '4px',
                                fontSize: '10px',
                                color: '#888'
                              }}>
                                +{room.tags.length - 4} more
                              </span>
                            )}
                          </div>
                        )}

                        {/* Access Request Section */}
                        {!hasRequestedAccess && !isApproved && !isDenied && (
                          <div style={{
                            background: '#333',
                            borderRadius: '12px',
                            padding: '16px',
                            marginBottom: '16px'
                          }}>
                            <h4 style={{
                              margin: '0 0 8px 0',
                              fontSize: '14px',
                              fontWeight: '600',
                              color: '#e5e5e5'
                            }}>
                              Request Access
                            </h4>
                            <p style={{
                              margin: '0 0 12px 0',
                              fontSize: '12px',
                              color: '#888'
                            }}>
                              Tell the host why you'd like to join their private sesh
                            </p>
                            <textarea
                              value={accessMessage}
                              onChange={(e) => setAccessMessage(e.target.value)}
                              placeholder="Hi! I'd love to join your sesh because..."
                              maxLength={300}
                              style={{
                                width: '100%',
                                minHeight: '60px',
                                padding: '12px',
                                background: colors.bgTertiary,
                                border: '1px solid #444',
                                borderRadius: '8px',
                                color: 'white',
                                fontSize: '14px',
                                outline: 'none',
                                resize: 'vertical',
                                boxSizing: 'border-box'
                              }}
                            />
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginTop: '8px'
                            }}>
                              <span style={{
                                fontSize: '12px',
                                color: accessMessage.length > 250 ? '#ef4444' : '#888'
                              }}>
                                {accessMessage.length}/300
                              </span>
                            </div>
                          </div>
                        )}

                        {/* Action Button */}
                        <button
                          onClick={() => handleRequestAccess(room.id)}
                          disabled={hasRequestedAccess || isApproved || isDenied || requestingAccess === room.id}
                          style={{
                            width: '100%',
                            padding: '12px',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            border: 'none',
                            cursor: (hasRequestedAccess || isApproved || isDenied || requestingAccess === room.id) ? 'not-allowed' : 'pointer',
                            backgroundColor: hasRequestedAccess 
                              ? '#f59e0b' 
                              : isApproved 
                                ? '#00d4aa' 
                                : isDenied 
                                  ? '#666' 
                                  : '#8b5cf6',
                            color: 'white',
                            fontSize: '14px',
                            fontWeight: '600',
                            transition: 'all 0.3s ease',
                            opacity: (hasRequestedAccess || isDenied || requestingAccess === room.id) ? 0.7 : 1
                          }}
                        >
                          {requestingAccess === room.id ? (
                            <>
                              <div style={{
                                width: '16px',
                                height: '16px',
                                border: '2px solid transparent',
                                borderTop: '2px solid white',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                              }} />
                              Sending Request...
                            </>
                          ) : hasRequestedAccess ? (
                            <>
                              <Clock size={16} />
                              Request Pending
                            </>
                          ) : isApproved ? (
                            <>
                              <CheckCircle size={16} />
                              Access Granted
                            </>
                          ) : isDenied ? (
                            <>
                              <X size={16} />
                              Request Denied
                            </>
                          ) : (
                            <>
                              <Send size={16} />
                              Request Access
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Empty State */}
              {filteredRooms.length === 0 && !loading && (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  color: '#888'
                }}>
                  <Lock size={64} style={{ marginBottom: '16px', opacity: 0.3 }} />
                  <h3 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '600' }}>
                    No private rooms found
                  </h3>
                  <p style={{ margin: '0', fontSize: '16px' }}>
                    {searchQuery || selectedCategory 
                      ? "Try adjusting your search or category filter"
                      : "No discoverable private rooms are currently available"
                    }
                  </p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{
          padding: '20px 32px',
          borderTop: '1px solid #333',
          background: colors.bgCard,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ fontSize: '12px', color: '#888' }}>
              {filteredRooms.length} private room{filteredRooms.length !== 1 ? 's' : ''} found
            </div>
            
            {/* Enter Invite Code Button */}
            <button
              onClick={() => setShowInviteCodeModal(true)}
              style={{
                padding: '10px 16px',
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                color: 'white',
                fontSize: '14px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s ease'
              }}
            >
              <Hash size={16} />
              Enter Invite Code
            </button>
          </div>
          
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              background: '#333',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              color: '#888',
              fontSize: '14px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#444';
              e.currentTarget.style.color = '#ccc';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#333';
              e.currentTarget.style.color = '#888';
            }}
          >
            Close
          </button>
        </div>
      </div>
      <InviteCodeModal
        isOpen={showInviteCodeModal}
        onClose={() => setShowInviteCodeModal(false)}
        currentUser={user}
        onJoinSuccess={handleInviteCodeJoin}
      />

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default PrivateRoomsModal;